"use strict";

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var innedit_1 = require("@innedit/innedit");

var Utilisateur = /*#__PURE__*/function () {
  function Utilisateur() {
    _classCallCheck(this, Utilisateur);
  }

  _createClass(Utilisateur, null, [{
    key: "get",
    value: function get(userId) {
      var userData = new innedit_1.UserData();
      return userData.findById(userId);
    }
  }, {
    key: "onChange",
    value: function onChange(next) {
      return innedit_1.UserData.onChange(next);
    }
  }, {
    key: "sendSignInLinkToEmail",
    value: function sendSignInLinkToEmail(email) {
      return innedit_1.UserData.sendSignInLinkToEmail(email);
    }
  }, {
    key: "signInWithEmailLink",
    value: function signInWithEmailLink(href) {
      innedit_1.UserData.signInWithEmailLink(href);
    }
  }, {
    key: "signInAnonymously",
    value: function signInAnonymously() {
      return innedit_1.UserData.signInAnonymously();
    }
  }, {
    key: "signInWithEmailAndPassword",
    value: function signInWithEmailAndPassword(email, password) {
      return innedit_1.UserData.signInWithEmailAndPassword(email, password);
    }
  }, {
    key: "signOut",
    value: function signOut() {
      return innedit_1.UserData.signOut();
    }
  }, {
    key: "watch",
    value: function watch(userId, next) {
      var userData = new innedit_1.UserData();
      return userData.watchById(userId, next);
    }
  }]);

  return Utilisateur;
}();

exports.default = Utilisateur;